import { UpdateContactDetailsTypes } from "../UpdateContactDetailsTypes";

export const findoutDifferenceInFields = (values: any, initialValues: any) => {
  return Object.entries(values).reduce((previousValue: any, [key, value]) => {
    const hasChanged = initialValues[key] !== value;
    if (hasChanged) {
      previousValue[key] = value;
    }
    return previousValue;
  }, {});
};

export const removeEmptyFields = (req: any) => {
  Object.keys(req).forEach(key => {
    if (req[key] === undefined) {
      delete req[key];
    }
  });
  return req;
};

export const getChangedPhoneNumber = (
  initialValues: any,
  phoneIn: UpdateContactDetailsTypes.TPhoneNumberField,
  mobile_number: string,
  country_code: string
) => {
  const { phone_id } = initialValues;
  const { phone_number_list = [] } = phoneIn ?? { phone_number_list: [] };
  let phone_number_list_array: UpdateContactDetailsTypes.TPhoneNumberList[] = [];
  if (phone_number_list.length > 0) {
    phone_number_list_array = phone_number_list?.filter(indivNumber => {
      if (indivNumber?.phone_id === phone_id) {
        return indivNumber;
      }
    });
    const completeNumber = mobile_number.replace(/[^\d]/g, "");
    phone_number_list_array[0].phone.number = completeNumber
      .replace(/\D/g, "")
      .slice(-7);
    phone_number_list_array[0].phone.comments =
      phone_number_list_array[0].phone.number;
    phone_number_list_array[0].phone.area_code = completeNumber
      .replace(/\D/g, "")
      .slice(1, 4);
    phone_number_list_array[0].__action_type = "Update";
  } else {
    phone_number_list_array = [
      {
        phone: {
          number: mobile_number
            .replace(/[^\d]/g, "")
            .replace(/\D/g, "")
            .slice(-7),
          area_code: mobile_number
            .replace(/[^\d]/g, "")
            .replace(/\D/g, "")
            .slice(1, 4),
          comments: mobile_number

            .replace(/[^\d]/g, "")
            .replace(/\D/g, "")
            .slice(-10),
          country_code: mobile_number.replace(/[^\d]/g, "")[0] || country_code
        },
        type: "Cell_Phone",
        phone_id: phone_id,
        __action_type: "Create"
      }
    ];
  }
  return phone_number_list_array;
};

export const frameTenantUpdateRequest = (values: any, initialValues: any) => {
  const changedFields = findoutDifferenceInFields(values, initialValues);
  const { first_name, last_name } = changedFields;
  const changeNamesReq = {
    ...(first_name && { first_name }),
    ...(last_name && { last_name })
  };
  return {
    ...(changeNamesReq && {
      name: changeNamesReq
    })
  };
};
